import HotLeadTemplate from "../../../../components/templates/LeadTemplates/HotLeadTemplate/HotLeadTemplate";

const HotLeads = () => {
  return <HotLeadTemplate />;
};

export default HotLeads;
